import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Stamp, ArrowRight } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import api from '../../services/api';
import { STATE_TONE, STATE_LABEL } from '../visa-costs/RenewalTracker';

// Visa renewal steps that are overdue or due soon; renders nothing when all clear.
export const RenewalStepsAlertCard = () => {
  const [rows, setRows] = useState(null);
  const navigate = useNavigate();
  useEffect(() => { api.get('/api/visa-costs/tracker/alerts').then((r) => setRows(r.data)).catch(() => setRows([])); }, []);
  if (!rows || !rows.length) return null;
  return (
    <Card className="border-amber-200" data-testid="renewal-steps-alert-card">
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center gap-2 text-base">
          <Stamp className="h-5 w-5 text-amber-600" /> Visa Renewal Steps
          <Badge className="bg-amber-100 text-amber-800 text-xs" data-testid="renewal-steps-count">{rows.length}</Badge>
          <button type="button" onClick={() => navigate('/employees?view=visa&sub=tracker')} className="ml-auto text-xs font-normal text-violet-700 hover:underline flex items-center gap-1" data-testid="renewal-steps-open-tracker">
            Open tracker <ArrowRight className="h-3 w-3" />
          </button>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-2 max-h-[320px] overflow-y-auto pr-1">
          {rows.map((r) => {
            const steps = r.tracker.steps.map((s, i) => ({ ...s, ...r.progress.states[i] })).filter((s) => ['overdue', 'due_soon'].includes(s.state));
            return (
              <div key={r.employee_id} className="p-3 rounded-lg border bg-white" data-testid={`renewal-alert-${r.employee_code}`}>
                <div className="flex items-center justify-between gap-2">
                  <p className="font-medium text-sm truncate">{r.name} <span className="text-xs text-gray-500">{r.employee_code}</span></p>
                  <span className="text-[11px] text-gray-500 shrink-0">Renewal {r.renewal_date}</span>
                </div>
                <div className="flex flex-wrap gap-1.5 mt-1.5">
                  {steps.map((s) => (
                    <span key={s.name} className={`text-[11px] px-1.5 py-0.5 rounded border ${STATE_TONE[s.state]}`}>
                      {s.name} · {STATE_LABEL[s.state]} · due {s.due_date}
                    </span>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
};
